// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1DNh-","right":"styles_right__1m0ab"};